/**
 *
 *  WeekView
 *  DateTimePicker
 *
 *  Created by Vladimir Shishlyannikov on 12/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useCallback, useState } from "react";
import PropTypes from "prop-types"; // use directly
// import moment from "moment-timezone";

// Utils
import * as dates from "../../../utils/dates";
import { getMomentWithTz } from "../../../utils/date";

import renderHeaders from "./renderHeaders";
import renderRow from "./renderRow";

function visibleDays(focused, region, culture) {
  var firstOfWeek = getMomentWithTz(focused, region).startOf("week");
  var endOfWeek = getMomentWithTz(focused, region).endOf("week");
  var current = firstOfWeek;
  var days = [];

  while (current.isSameOrBefore(endOfWeek, "day")) {
    days.push(current.toDate());
    current.add(1, "day");
  }

  return days;
}

const WeekView = ({
  className,
  style,
  focused,
  culture,
  region,
  activeId,
  ...rest
}) => {
  const [highlightedDate, sethighlightedDate] = useState(false);

  var rows = visibleDays(focused, region, culture);

  const handleWeekDayMouseEnter = useCallback((date) => {
    sethighlightedDate(date);
  });

  const handleWeekDayMouseLeave = useCallback((date) => {
    sethighlightedDate(date);
  });

  return (
    <table
      role="grid"
      tabIndex="-1"
      aria-activedescendant={activeId || null}
      className={`${
        className ? className + " " : ""
      }tbk-w-full tbk-h-auto tbk-table-fixed tbk-border-spacing-0 tbk-outline-none`}
      style={style}
    >
      <thead className="tb-calendar-head">
        <tr className="tb-calendar-row">
          <th />
          {renderHeaders({
            week: rows,
            highlighted: highlightedDate,
            region,
            ...rest,
          })}
          <th />
        </tr>
      </thead>
      <tbody className="tb-calendar-body">
        {renderRow({
          rows,
          activeId,
          region,
          highlighted: highlightedDate,
          onMouseEnter: handleWeekDayMouseEnter,
          onMouseLeave: handleWeekDayMouseLeave,
          ...rest,
        })}
      </tbody>
    </table>
  );
};

WeekView.propTypes = {
  activeId: PropTypes.string,
  culture: PropTypes.string,
  today: PropTypes.instanceOf(Date),
  value: PropTypes.instanceOf(Date),
  focused: PropTypes.instanceOf(Date),
  /**
   * Available days of the week. If not present then it will be disabled.
   *
   * @example ['prop', ['availableDays', '['2018-11-03', ..]']]
   */
  availableDays: PropTypes.array,
  min: PropTypes.instanceOf(Date),
  max: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,

  dayFormat: PropTypes.object,

  disabled: PropTypes.bool,
  prevDisabled: PropTypes.bool.isRequired,
  nextDisabled: PropTypes.bool.isRequired,
  onMoveLeft: PropTypes.func.isRequired,
  onMoveRight: PropTypes.func.isRequired,
};

export default WeekView;
